/**
 * Shared runtime type guards.
 *
 * Each guard narrows `unknown` to a concrete type in a single `value is T`
 * predicate, so call sites branch on domain values instead of scattering
 * `typeof` checks through business logic. The `typeof` inside each body is
 * intentional: predicates are the sanctioned boundary-parse mechanism.
 */
export function isString(value: unknown): value is string {
  return typeof value === 'string'
}

export function isNumber(value: unknown): value is number {
  return typeof value === 'number'
}

export function isBoolean(value: unknown): value is boolean {
  return typeof value === 'boolean'
}

export function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value)
}

export function isSafeIntegerValue(value: unknown): value is number {
  return typeof value === 'number' && Number.isSafeInteger(value)
}

export function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0
}
